export default "/images/b003ff724027771dacac15ec09859d7e.avif";